import React from "react";
import { useNavigate } from "react-router-dom";
import "../../style/pages/categoriespage/relatedproduct.css";

import s1 from "../../media3/categories/a24.png";
import s2 from "../../media3/categories/r18.png";
import s3 from "../../media3/categories/g12.png";
import s4 from "../../media3/categories/k18.png";

const related = [
  {
    name: "SG Agent",
    img: s1,
    price: "$340.00",
    path: "/categories/agents",
  },
  {
    name: "Black 68",
    img: s2,
    price: "$140.00",
    path: "/categories/rifle",
  },
  {
    name: "The G87",
    img: s3,
    price: "$240.00",
    path: "/categories/gloves",
  },
  {
    name: "Killer",
    img: s4,
    price: "$250.00",
    path: "/categories/knives",
  },
  
];

const RelatedProduct = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  return (
    <div className="related-product-section">
      <div className="related-title">Related Product</div>
      <div className="related-list">
        {related.map((item, idx) => (
          <div
            className="related-card"
            key={idx}
            role="button"
            tabIndex={0}
            onClick={() => handleCardClick(item.path)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") handleCardClick(item.path);
            }}
            style={{ cursor: "pointer" }}
          >
            <img src={item.img} alt={item.name} className="related-img" />
            <div className="related-meta">
              <div className="related-name">{item.name}</div>
              <div className="related-price">{item.price}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedProduct;
